import { useState } from 'react';
import { Stagiaire, StagiaireStatus, WebLinkType } from '../types';
import { displayLocation, extractSocialNetworkName } from '../utils';
import { createPortal } from 'react-dom';
import StagiaireModal from './StagiaireModal';

interface StagiaireCardProps {
    stagiaire: Stagiaire;
}

export default function StagiaireCard({ stagiaire }: StagiaireCardProps) {
    const [showModal, setShowModal] = useState(false);

    const { nomUsagePro, photoPro, lieuxActivite, presenceWebs, passageCertifications } = stagiaire;

    const hasMainLocation = lieuxActivite.length > 0;
    const mainWebLink = presenceWebs.length > 0 ? presenceWebs[0].url : null;

    const socials = presenceWebs.filter(web => web.type === WebLinkType.ReseauSocial);

    const apiUrl = import.meta.env.VITE_API_URL || 'https://localhost';
    const photo_base_url = apiUrl + "/uploads/";
    const photo_placeholder = stagiaire.sexe === 'F' ? './assets/img/placeholder-woman.png' : './assets/img/placeholder-man.png';

    const photoUrlCurated = photoPro ? (photo_base_url + photoPro.url) : photo_placeholder;

    return (
        <>
            {showModal && (
                createPortal(
                    <StagiaireModal stagiaire={stagiaire} onClose={() => setShowModal(false)} />,
                    document.body
                )
            )}
            <div className="stagiaire-card" onClick={() => setShowModal(true)}>
                <img src={photoUrlCurated} alt={`${stagiaire.nomUsagePro}`} className="stagiaire-card__photo-pro" />

                <div className='stagiaire-card__content'>
                    <div className='stagiaire-card__info'>
                        <h2 className='stagiaire-card__name'>{nomUsagePro}</h2>

                        {stagiaire.statut === StagiaireStatus.Associe &&
                            <h3 className='stagiaire-card__title'>
                                <img className='deco_icon' src="./assets/img/icons/verified.png" alt="Quote icon" />
                                {stagiaire.sexe === "M" ?
                                    "Formateur associé à l'École" :
                                    "Formatrice associée à l'École"
                                }
                            </h3>
                        }

                        {passageCertifications.length > 0 && (
                            <h3 className='stagiaire-card__title'>
                                <img className='deco_icon' src="./assets/img/icons/certificate.png" alt="Certification icon" />
                                {passageCertifications.map((certif, index) => (
                                    <span key={index}>
                                        {stagiaire.sexe === "M" ?
                                            "Certifié " :
                                            "Certifiée "}
                                        {certif.certification.type} en {new Date(certif.dateDebutValidite).getFullYear()}
                                    </span>
                                ))}
                            </h3>
                        )}

                        {hasMainLocation &&
                            <h4 className='stagiaire-card__title'>
                                <img className='deco_icon' src="./assets/img/icons/localisation.png" alt="Location icon" />
                                <span>{lieuxActivite
                                    .map(displayLocation)
                                    .join(', ')}</span>
                            </h4>
                        }
                        {stagiaire.visio && <h4 className='stagiaire-card__title'>
                            <img className='deco_icon' src="./assets/img/icons/videocall.svg" alt="Videocall icon" />
                            <span>Donne cours en visio</span>
                        </h4>
                        }
                    </div>
                    <div className='stagiaire-card__weblinks'>

                        {mainWebLink && <a href={mainWebLink} target="_blank" rel="noopener noreferrer">
                            <img className='deco_icon' src="./assets/img/icons/link.png" alt="Web icon" />
                            Site web
                        </a>}
                        <div className='stagiaire-card__socials'>
                            {socials.map((web, index) => {
                                const socialNetwork = extractSocialNetworkName(web.url)?.toLowerCase();

                                const iconUrl = "./assets/img/icons/" + (socialNetwork ? 'logo-' + socialNetwork + '.png' : 'logo-default-network.png');

                                return (
                                    <a key={index} href={web.url} target="_blank" rel="noopener noreferrer">
                                        <img src={iconUrl} alt={socialNetwork} />
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}